module.exports = __webpack_public_path__ + "img/icon-no-video.f545931a.png";